"use client";


import SectionPage from "@/components/common/section-page";
import InformationsEssentiellesCard from "@/components/site-officiel/accueil/informations-essentielles-card";
import EvenementCard from "@/components/site-officiel/accueil/evenement-card";
import DecouvrirCiCard from "@/components/site-officiel/accueil/decouvrir-ci-card";
import VivezVotreExperienceSection from "@/components/site-officiel/accueil/vivez-votre-experience-section";
import CarouselAcceuil from "@/components/site-officiel/accueil/carousel-accueil";

import {
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    BreadcrumbList,
    BreadcrumbSeparator,
} from "@/components/ui/breadcrumb"
import {ChartBar} from "lucide-react";
import RemplissezVosJoursDeVie from "@/components/site-officiel/accueil/remplissez-vos-jours-de-vie";
import NosLocaux from "@/components/site-officiel/accueil/nos-locaux";
// TODO: Replace with React.lazy - next/dynamic removed during Vite migration
// const WelcomeVideo = React.lazy(() => import("@/components/site-officiel/accueil/welcome-video"));

export default function Home() {

    return (
        <div className={"flex flex-col gap-6 my-6"}>
            <SectionPage sectionType="2xl">
                <CarouselAcceuil/>
            </SectionPage>

            <SectionPage sectionType="2xl">
                <div className={"flex flex-col md:flex-row  md:justify-between items-center gap-4"}>
                    <Breadcrumb>
                        <BreadcrumbList>
                            <BreadcrumbItem>
                                <BreadcrumbLink href={"/"}>Accueil</BreadcrumbLink>
                            </BreadcrumbItem>
                            <BreadcrumbSeparator/>
                            <BreadcrumbItem>
                                <BreadcrumbLink href={"/"}>Site Officiel</BreadcrumbLink>
                            </BreadcrumbItem>
                        </BreadcrumbList>
                    </Breadcrumb>

                  
                    <div className={"bg-bleu-marine p-2 text-white front-exo-regular flex items-center gap-4"}>
                        <ChartBar size={24}/>
                        {"37534 vues totales , 98 vues aujourd'hui"}
                    </div>
                </div>
            </SectionPage>

            <VivezVotreExperienceSection/>

            <SectionPage sectionType="2xl">
                <RemplissezVosJoursDeVie />
            </SectionPage>

            <SectionPage sectionType="2xl">
                <DecouvrirCiCard/>
            </SectionPage>

            <SectionPage sectionType="2xl">
                <NosLocaux/>
            </SectionPage>

            <SectionPage sectionType="2xl">
                <EvenementCard/>
            </SectionPage>

            <SectionPage sectionType="2xl">
                <InformationsEssentiellesCard/>
            </SectionPage>
        </div>
    );
}
